import { render, staticRenderFns } from "./RegisteredChannelsPage.vue?vue&type=template&id=1fcbcde4&scoped=true&"
import script from "./RegisteredChannelsPage.vue?vue&type=script&lang=js&"
export * from "./RegisteredChannelsPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredChannelsPage.vue?vue&type=style&index=0&id=1fcbcde4&scoped=true&lang=css&"
import style1 from "./RegisteredChannelsPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbcde4",
  null
  
)

export default component.exports